export default "__VITE_ASSET__BU_poONN__"